import { useEffect, useRef, useState } from 'react';

export const useScrollState = () => {
  const [isScroll, setIsScroll] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const isScrollRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const newIsScroll = currentScrollY > 0;

      setScrollY(currentScrollY);

      if (newIsScroll !== isScrollRef.current) {
        isScrollRef.current = newIsScroll;
        setIsScroll(newIsScroll);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { isScroll, scrollY };
};
